<template>
  <div class="classroomArrangementItem" @click="clickItem">
    <div class="bgtype" :class="bgimg">
      <span class="type">{{ item.typeText }}</span>
    </div>
    <div class="item-content">
      <div class="title">{{ item.name }}</div>
      <div class="line"></div>
      <div class="content">
        <div class="detail" v-if="item.className">
          <img
            :src="require('_teas/public/img/product/bootScreen/icon-hd.png')"
            alt=""
            srcset=""
          />
          <div class="text">{{item.className}}</div>
        </div>
        <div class="detail">
          <img
            :src="
              require('_teas/public/img/product/bootScreen/icon-teacher.png')
            "
            alt=""
            srcset=""
          />
          <div class="text">{{ item.speakerText }}</div>
        </div>
        <div class="detail">
          <img
            :src="require('_teas/public/img/product/bootScreen/icon-time.png')"
            alt=""
            srcset=""
          />
          <div class="text">
            {{ item.affairDate }} {{ item.beginTime }}-{{ item.endTime }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "classroomArrangementItem",
  data() {
    return {
      roundNumber: 1,
    };
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    isCurrent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    bgimg: function () {
      switch (this.roundNumber) {
        case 1:
          return "img-hybgone";
        case 2:
          return "img-hybgtwo";
        case 3:
          return "img-hybgthree";
        case 4:
          return "img-hybgfour";
        case 5:
          return "img-hybgfive";
        case 6:
          return "img-hybgsix";
        default:
          return "img-hybgone";
      }
    },
  },
  created() {
    this.roundNumber = Math.round(Math.random() * 5 + 1);
  },
  methods: {
    // 点击方法
    clickItem() {
      if (!this.isCurrent) return;
      var url = '/mobile/bootScreen/transverse/bootScreenSignIn?id=' + this.item['id'] + '&relId=' + this.item['relId'] + '&courseNoonId=' + this.item['courseNoonId'] + '&type=' + this.item['typeValue'] + '&attendMode=' + this.item['courseAttendMode']
      this.$router.push({
        path: url
      })
    },
  },
};
</script>

<style>
</style>